<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsMarkdown',
  
})
</script>
<template>
  <div class="viewer-container">
    <v-md-preview
      :text="markdown"
      class="viewer article-container"
    />
  </div>
</template>

<script setup lang="ts" name="TlbsMarkdown">
interface Props {
  markdown: string,
}

withDefaults(defineProps<Props>(), {
  markdown: '',
});

</script>

<style lang="less" scoped>
  .viewer-container {
    min-width: 1000px;
  }
  .viewer {
      text-align: initial;
      padding: 20px;
      height: 100%;
      overflow: auto;
  }
</style>
